import { Aspect } from '@teambit/harmony';

export const ComponentAspect = Aspect.create({
  id: 'teambit.component/component',
  dependencies: [],
  defaultConfig: {},
});

export default ComponentAspect;
